import React from "react";
import GridContainer from "@jumbo/components/GridContainer";
import PageContainer from "@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "@jumbo/utils/IntlMessages";
import { Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import HubbleRefereeDetailsContainer from "@jumbo/Dashboards/HubbleContainer/HubbleRefereeDetailsContainer";

const breadcrumbs = [
    { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
    { label: <IntlMessages id={"pages.hubbleReferee"} />, link: "/hubble" },
    {
        label: <IntlMessages id={"pages.hubbleRefereeDetails"} />,
        isActive: true,
    },
];

const HubbleRefereeDetails = () => {
    return (
        <PageContainer
            heading={<IntlMessages id="pages.hubbleRefereeDetails" />}
            breadcrumbs={breadcrumbs}
        >
            <GridContainer>
                <Grid item xs={12}>
                    <div style={{ marginBottom: "10px" }}>
                        <IntlMessages id="pages.hubbleRefereeDetails.description" />
                    </div>
                    <Divider />
                    <div style={{ marginTop: 24 }}>
                        <HubbleRefereeDetailsContainer />
                    </div>
                </Grid>
            </GridContainer>
        </PageContainer>
    );
};

export default HubbleRefereeDetails